<div class="container">
  <div class="row justify-content-center align-items-center min-vh-100">
    <div class="col-12 col-sm-8 col-md-6 col-lg-4">
      <mat-card class="text-center">
        <mat-card-header>
          <mat-card-title>
            <div class="text-center w-100">
              <mat-icon class="page-icon text-primary">verified_user</mat-icon>
              <h2>Sesión Cerrada</h2>
              <p class="text-muted small text-uppercase fw-bold">Desconexión Exitosa</p>
            </div>
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="alert alert-info">
            Has salido del sistema de forma segura. Se ha limpiado la caché de
            <strong>permisos y autorizaciones</strong> de tu navegador.
          </div>
        </mat-card-content>

        <mat-card-actions class="px-3 pb-3">
          <button mat-flat-button color="primary" class="w-100" (click)="goBack()">
            <mat-icon>login</mat-icon>
            Volver al Inicio de Sesión
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
